import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdminService } from '../admin/admin.service';

@Injectable()
export class DiplomaPaperService {

  constructor(
    private http: HttpClient,
    private adminService: AdminService
  ) { }

  getById(id, callback) {
    this.http.get('/diploma-paper/' + id).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getDetailsForEditing(id, callback) {
    Observable.forkJoin(
      this.http.get('/diploma-paper/' + id),
      this.http.get('/teacher/diploma-paper/' + id + '/' + this.adminService.classId)
    ).subscribe(
      (res: any) => {
        res[1].data = res[1].data.map(data => data.user);
        callback(null, { paper: res[0], teacherData: res[1] });
      },
      err => {
        callback(err);
      }
    );
  }

  getDiplomaTypes(callback) {
    this.http.get('/diploma-paper/type/all').subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  getTeacherList(id, page, name, callback) {
    const params = { page, name };
    id = id || 'all'
    this.http.get('/teacher/diploma-paper/' + id + '/' + this.adminService.classId, { params }).subscribe(
      (res: any) => {
        res.data = res.data.map(data => data.user);
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  create(payload, callback) {
    this.http.post('/diploma-paper', payload).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  createOrUpdate(payload, callback) {
    if (payload.id) {
      this.http.put('/diploma-paper/' + payload.id, payload).subscribe(
        res => {
          callback(null, res);
        },
        err => {
          callback(err);
        }
      );
    } else {
      this.http.post('/diploma-paper', payload).subscribe(
        res => {
          callback(null, res);
        },
        err => {
          callback(err);
        }
      );
    }
  }

  delete(id, callback) {
    this.http.delete('/diploma-paper/' + id).subscribe(
      res => {
        callback(null, res);
      },
      callback
    );
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/services/diploma-paper/diploma-paper.service.ts